import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Layers icon component for the Sub-Module action type in selectors and lists.
 */
import { Layers } from "lucide-react";
/**
 * Icon for the sub-module action type.
 * Uses the Layers icon from lucide-react to represent nested/hierarchical content.
 * @param root0 - The component props
 * @param root0.className - CSS class name for styling
 * @returns The Layers icon
 */
export function Icon({ className }) {
    return _jsx(Layers, { className: className });
}
//# sourceMappingURL=Icon.js.map